<script>
import Layout from "../../_layouts/main"
import PageHeader from "@/components/page-header"
import Document from '../../../components/api/document'

/**
 * Dashboard Component
 */
export default {
  components: {
    Layout,
    PageHeader,
    Document
  },
  data() {
    return {
      title: this.$t('게임사'),
      apiUrl: process.env.VUE_APP_API_SERVER_URL + 'vendors',
      response: '',
      body: {
        categoryKey: { type: 'list', list: ['casino', 'hotel', 'slot'], value: 'casino', desc: this.$t('text.api.gameCategory_desc'), required: true },
      }
    };
  },
  mounted() {
    /*
    let host = location.host
    if (host.indexOf('localhost') > -1 || host.indexOf('127.0.0.1') > -1) {
      host = 'http://127.0.0.1:39011/'
    } else {
      host = `https://api.${host}/`
    }

     */
    const host = process.env.VUE_APP_API_SERVER_URL
    this.apiUrl = host + 'vendors'
    // 응답값 설정
    this.response = '{\n' +
        ' "code": 0, \t\t\t// 응답값(0이 아니면 오류)\n' +
        ' "vendors": [ \t\t\t// 게임사 목록\n' +
        '  {\n' +
        '   "maxBetAmount": 10000000, \t// 최대 배팅 금액\n' +
        '   "categoryKey": "slot", \t// 게임사 카테고리\n' +
        '   "names": {\n' +
        '    "ko": "프라그마틱 슬롯",\n' +
        '    "en": "Pragmatic Slot"\n' +
        '   },\n' +
        '   "key": "pragmatic_slot" \t// 게임사 고유키\n' +
        '  },\n' +
        '  .\n' +
        '  .\n' +
        '  .\n' +
        ' ]\n' +
        '}'
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="card-title">{{ apiUrl }}</div>
            <div class="card-title-desc">{{ $t('text.api_vendors_desc') }}</div>
            <hr/>
            <Document :data="body" :apiUrl="apiUrl" :response="response" :require-vendors="false" :require-ip-address="false" :require-request-key="false" />
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
